export default "__VITE_ASSET__BgLCJA_5__"